import type { FaireProductEntity } from "../../entity_types/product";

export const p_dq3f2amnch: FaireProductEntity = {
  token: "p_dq3f2amnch",
  type: "product",
  name: "Raw Minnesota Honey",
  brandName: "Big Dipper Honey",
  imageUrl:
    "https://cdn.faire.com/fastly/3087872a68b27c5d4906d44c8827049ce980e7c15a657d9393b2fdcfc784cdb1.jpeg",
  priceDollars: 7,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b0d3e3cc965a7b6a7bf0263bbf612ffe5877276b13cf4501a374d32a08c2944e.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
